import React from "react"
import { Row, Col, Container, Button } from "react-bootstrap"
import { imageFile } from '../../components/Utilities/Image-file'
import { safeName } from '../../components/Utilities/Safe-name'
import Icon from "../../assets/Union.svg"
import { trackCustomEvent } from 'gatsby-plugin-google-analytics'


// Prospects download component
//

// EXAMPLE:
//
// <ProspectsDownload data={issue_data} />
//
// data: see data collection on the article and Prospects issue pages


function filterDownloads(data) {
  //console.log(data)

  // output
  // -----------------------------------
  let download = [];
  if(typeof data === 'object') {
    let field_hex_color = data.field_hex_color
    let colour_class = safeName(data.colour_name)

    let {docTitle, docDownload, imageRelPath} = ""

    if(data?.file_data){
      if(data.file_data?.relationships?.field_upload_document?.name) {
        docTitle = data.file_data.relationships.field_upload_document.name
      }
      if(data.file_data?.relationships?.field_upload_document?.relationships) {
        if(data.file_data.relationships.field_upload_document.relationships?.field_document) {
          if(data.file_data.relationships.field_upload_document.relationships.field_document?.localFile) {
            docDownload = data.file_data.relationships.field_upload_document.relationships.field_document.localFile.publicURL
          }
        }
      }

      // - brochure image
      if(data?.file_data?.relationships?.field_image) {
        if(data.file_data.relationships.field_image?.relationships?.media__image[0]?.relationships?.image) {
          imageRelPath = imageFile(data.file_data.relationships.field_image.relationships.media__image[0].relationships.image, docTitle)
        }
      }
    }

    if(!data.file_data) {
      return (<></>)
    }
    else {
      download = (
        <section className={"text-left paragraph__content--text-and_documents "+colour_class}  style={{ background: field_hex_color }}>
          <Container fluid>
            <Row>
              <Col xs={12} md={6} lg={4}>
                <div className="paragraph__img">
                  <a onClick={e => {
                    trackCustomEvent({
                      category: "Document download",
                      action: "Click",
                      label: docTitle
                    })
                  }} href={docDownload} target="_blank" rel="noreferrer">
                    {imageRelPath}
                  </a>
                </div>
              </Col>
              <Col xs={12} md={6} lg={8}>
                <div className="paragraph__text right">
                  <div className="paragraph__title">
                    <div className="h1">{docTitle}</div>
                  </div>
                  <a onClick={e => {
                    trackCustomEvent({
                      category: "Document download",
                      action: "Click",
                      label: docTitle
                    })
                  }} href={docDownload} target="_blank" rel="noreferrer">
                    <Button variant="secondary">Download this issue <Icon width="24" /></Button>
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      )
      return (download)
    }

  }
  else {
    return (download)
  }

}



const ProspectsDownload = (props) => {

  return (
    <>
      {filterDownloads(props.data)}
    </>
  )
}


export default ProspectsDownload

